var _path, _rect, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _ellipse3, _ellipse4, _path6, _path7, _path8, _path9, _path0, _g, _ellipse5, _ellipse6, _rect2, _g2, _rect3, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureContratIllu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 179,
    viewBox: "0 0 199 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M186.833 102.575C193.179 61.4352 164.974 22.9396 123.833 16.5929C82.6933 10.2462 44.1976 38.4518 37.8509 79.5919C31.5042 120.732 59.7098 159.228 100.85 165.574C141.99 171.921 180.486 143.715 186.833 102.575Z",
    fill: "#EBF2F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.2904,
    height: 27.2903,
    rx: 6.82259,
    transform: "matrix(-0.984381 -0.176053 -0.176054 0.984381 183.202 40.7877)",
    fill: "#FFF6CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.07 58.3265C159.449 58.7933 159.987 59.1049 160.581 59.2028L171.006 61.082C171.533 61.182 172.078 61.0889 172.542 60.8195C173.007 60.5496 173.359 60.1202 173.532 59.6116L175.778 53.0654C175.883 52.7596 175.919 52.4346 175.886 52.1132C175.852 51.7917 175.749 51.4814 175.583 51.2038C175.418 50.9261 175.194 50.6878 174.927 50.5052C174.662 50.3235 174.36 50.2014 174.043 50.1473L170.511 49.5107L170.924 47.2167C171.065 46.4364 170.89 45.6321 170.438 44.9809C169.985 44.3297 169.293 43.8848 168.512 43.7441C168.237 43.6944 167.957 43.8118 167.8 44.0438L163.853 49.8553L162.315 49.5781C161.725 49.4626 161.112 49.5669 160.593 49.8717C160.073 50.1776 159.682 50.6641 159.496 51.2389C159.486 51.2691 159.479 51.3 159.473 51.3313L158.529 56.5675C158.524 56.5988 158.52 56.6305 158.519 56.6623C158.492 57.2658 158.688 57.858 159.07 58.3265ZM160.814 57.8033C160.561 57.7623 160.332 57.6298 160.17 57.4309C160.017 57.2428 159.934 57.0078 159.935 56.7661L160.86 51.6361C160.943 51.4093 161.103 51.2179 161.312 51.0951C161.533 50.9653 161.794 50.9213 162.046 50.9712L163.357 51.2076L162.126 58.0396L160.827 57.8053L160.814 57.8033ZM168.677 45.2776L164.853 50.9093L163.522 58.2913L171.269 59.6878C171.461 59.7246 171.66 59.6908 171.829 59.5926C171.999 59.4944 172.126 59.3384 172.19 59.1534L174.435 52.6067C174.473 52.4956 174.487 52.3776 174.474 52.2608C174.462 52.1439 174.425 52.0311 174.365 51.9301C174.304 51.8291 174.223 51.7425 174.126 51.6761C174.029 51.6097 173.919 51.5652 173.803 51.5457L173.795 51.5443L169.561 50.7812C169.175 50.7117 168.919 50.3427 168.989 49.9572L169.528 46.965C169.602 46.555 169.51 46.1325 169.272 45.7903C169.119 45.5698 168.914 45.3943 168.677 45.2776Z",
    fill: "#0D0D0D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3600_1559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 16,
    width: 180,
    height: 151
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.851 102.046C193.187 60.9715 167.639 22.9406 129.787 17.1011C91.9348 11.2617 16.0014 52.2923 9.66484 93.3664C6.52234 113.736 11.072 139.093 31.171 151.319C51.5995 163.746 87.7604 162.9 106.84 165.844C144.692 171.683 180.514 143.12 186.851 102.046Z",
    fill: "#F5FAFA"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3600_1559)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3600_1559)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.878 126.75C23.878 137.42 29.4391 146.071 36.2991 146.071C37.8479 146.071 46.7729 146.877 48.1403 146.071C52.8292 143.308 48.7202 135.011 48.7202 126.75C48.7202 118.488 53.9934 110.815 49.3045 108.052C47.9372 107.246 37.8479 107.428 36.2991 107.428C29.4391 107.428 23.878 116.079 23.878 126.75Z",
    fill: "#DFE8E8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4211,
    cy: 19.3215,
    rx: 12.4211,
    ry: 19.3215,
    transform: "matrix(-1 -1.99706e-09 -1.99706e-09 1 59.5908 107.428)",
    fill: "#EBF2F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5987,
    cy: 10.1801,
    rx: 6.5987,
    ry: 10.1801,
    transform: "matrix(-1 -1.99706e-09 -1.99706e-09 1 53.7695 116.571)",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.081 126.75C122.081 137.42 127.642 146.071 134.502 146.071C136.051 146.071 144.976 146.877 146.343 146.071C151.032 143.308 146.923 135.011 146.923 126.75C146.923 118.488 152.197 110.815 147.508 108.052C146.14 107.246 136.051 107.428 134.502 107.428C127.642 107.428 122.081 116.079 122.081 126.75Z",
    fill: "#DFE8E8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4211,
    cy: 19.3215,
    rx: 12.4211,
    ry: 19.3215,
    transform: "matrix(-1 -1.99706e-09 -1.99706e-09 1 157.794 107.427)",
    fill: "#EBF2F2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5987,
    cy: 10.1801,
    rx: 6.5987,
    ry: 10.1801,
    transform: "matrix(-1 -1.99706e-09 -1.99706e-09 1 151.973 116.57)",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.271 131.717L216.988 104.709L82.2972 88.2957L34.3596 122.991L98.7939 131.717L214.271 131.717Z",
    fill: "#DFE8E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7921 127.793C98.7921 138.464 104.353 147.114 111.213 147.114C112.762 147.114 121.687 147.92 123.054 147.114C127.743 144.351 123.634 136.054 123.634 127.793C123.634 119.531 128.907 111.858 124.219 109.095C122.851 108.289 112.762 108.471 111.213 108.471C104.353 108.471 98.7921 117.122 98.7921 127.793Z",
    fill: "#DFE8E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.991 126.733C183.991 137.404 189.552 146.054 196.412 146.054C197.961 146.054 206.886 146.86 208.254 146.054C212.942 143.292 208.833 134.995 208.833 126.733C208.833 118.471 214.107 110.798 209.418 108.035C208.05 107.23 197.961 107.411 196.412 107.411C189.552 107.411 183.991 116.062 183.991 126.733Z",
    fill: "#DFE8E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.873 60.8715C189.313 66.3563 204.179 78.1154 209.807 83.3093C214.077 83.3093 215.436 84.3481 216.018 86.4257C217.571 87.2567 217.7 92.1737 217.571 94.5282L219.317 105.332L219.123 127.977L216.6 129.224C216.471 126.107 216.173 119.501 216.018 118.005C215.824 116.135 213.689 105.332 204.761 105.747C195.834 106.163 193.505 118.42 193.117 124.238C192.806 128.891 192.987 134.071 193.117 136.08L132.952 135.456C133.405 133.31 134.272 128.185 134.117 124.861C133.456 114.542 128.632 109.503 125.254 107.673C124.226 107.116 123.047 106.966 121.878 106.938C121.26 106.923 120.575 106.91 119.878 106.905C117.254 106.885 114.603 107.683 112.99 109.754C107.624 116.64 107.334 128.979 107.334 132.756C106.091 136.08 102.158 135.941 100.347 135.456C76.7984 135.664 27.9163 136.08 20.7742 136.08C16.5821 133.088 15.7928 128.462 15.9222 126.523C15.9869 123.476 16.0775 116.634 15.9222 113.642C15.7281 110.318 15.9222 107.409 19.2215 107.409C20.9683 97.2291 27.1788 95.3593 32.8071 94.736C38.086 89.2512 50.7918 85.1099 56.4848 83.7248C58.4903 81.9243 64.9466 76.5364 74.7282 69.3896C86.9552 60.456 102.093 57.7551 111.991 57.7551C145.179 56.3008 166.528 59.0017 174.873 60.8715Z",
    fill: "#DFE8E8",
    stroke: "white",
    strokeWidth: 1.48697
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3600_1559",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 57,
    width: 204,
    height: 79
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M174.29 60.6626C188.73 66.1474 203.596 77.9064 209.224 83.1004C213.494 83.1004 214.853 84.1392 215.435 86.2168C216.988 87.0478 217.117 91.9647 216.988 94.3193L218.734 105.123L218.54 127.768L216.017 129.015C215.888 125.898 215.59 119.292 215.435 117.796C215.241 115.926 213.106 105.123 204.178 105.538C195.251 105.954 192.922 118.211 192.534 124.029C192.223 128.682 192.404 133.863 192.534 135.871L132.369 135.248C132.822 133.101 133.689 127.976 133.534 124.652C132.757 112.519 126.223 107.685 123.053 106.785C121.371 106.716 117.464 106.619 115.29 106.785C107.139 112.394 106.751 128.184 106.751 132.547C105.508 135.871 101.575 135.732 99.7637 135.248C76.2154 135.455 27.3333 135.871 20.1911 135.871C15.999 132.879 15.2098 128.253 15.3392 126.314C15.4039 123.267 15.4944 116.425 15.3392 113.433C15.1451 110.109 15.3392 107.2 18.6385 107.2C20.3852 97.0202 26.5958 95.1504 32.2241 94.5271C37.503 89.0423 50.2088 84.901 55.9018 83.5159C57.9072 81.7154 64.3636 76.3275 74.1452 69.1806C86.3722 60.2471 101.51 57.5462 111.408 57.5462C144.596 56.0919 165.945 58.7927 174.29 60.6626Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3600_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4631 126.522L94.5144 126.522C95.3958 126.522 95.9576 127.463 95.5395 128.239L93.8835 131.312C93.6803 131.689 93.2866 131.924 92.8584 131.924L20.4567 131.924C19.9516 131.924 19.5041 131.598 19.3487 131.118L18.3551 128.045C18.1119 127.293 18.6727 126.522 19.4631 126.522Z",
    fill: "#F5FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.945 83.3074L163.81 62.9471L155.077 62.9471C153.718 63.0164 150.303 63.8613 147.508 66.6868C144.713 69.5123 135.604 78.6675 131.399 82.8919L131.399 84.7617L165.945 83.3074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.024 83.0994L144.402 62.3236L144.402 61.7003L104.81 61.2848C102.093 61.1463 94.8733 61.4926 87.7312 63.9857C74.689 68.9719 64.7004 78.8057 61.3364 83.0994L124.024 83.0994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2706 98.4734C93.6312 98.972 77.3156 102.698 69.4877 104.498L69.5127 104.531C73.1788 109.281 73.9757 110.314 84.6259 109.692C95.3003 109.069 101.899 107.199 108.109 104.498C114.32 101.798 111.215 100.343 108.109 98.8889C102.287 96.8113 99.57 97.8501 96.2706 98.4734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.383 82.8914C190.748 82.7252 194.798 78.667 196.027 76.6587C190.399 71.8806 183.412 67.7255 176.619 65.0243C172.909 63.5487 169.18 63.0159 167.692 63.1544L171.185 82.8914C172.932 82.9607 178.017 83.0576 184.383 82.8914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1338 98.1957C26.9785 101.852 27.6306 105.378 27.9541 107.317C27.6953 107.732 26.7896 109.103 25.237 111.264C24.2666 111.264 23.4903 111.472 21.5495 109.395C19.2206 106.278 24.0285 97.3646 27.1338 98.1957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.714 76.4515C134.659 77.2826 134.439 82.615 135.086 85.1773C135.927 85.7314 138.619 86.8394 142.655 86.8394C147.701 86.8394 149.448 85.1773 149.836 82.4765C150.224 79.7756 147.119 75.8282 140.714 76.4515Z",
    fill: "#DFE8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3169 106.064C66.9235 106.064 70.0029 110.364 71.3418 112.513C64.185 115.953 60.3266 116.292 59.292 116.031L32.4538 116.031C26.6115 116.031 25.7595 113.686 26.0638 112.513L30.4455 106.064L65.3169 106.064Z",
    fill: "#EBF2F2"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4211,
    cy: 19.3215,
    rx: 12.4211,
    ry: 19.3215,
    transform: "matrix(-1 -1.99706e-09 -1.99706e-09 1 134.009 108.474)",
    fill: "#EBF2F2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5987,
    cy: 10.1801,
    rx: 6.5987,
    ry: 10.1801,
    transform: "matrix(-1 -1.99706e-09 -1.99706e-09 1 127.691 118.144)",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.5007,
    height: 24.5007,
    rx: 6.12518,
    transform: "matrix(-0.941022 0.338344 0.338345 0.941022 113.516 7.29523)",
    fill: "#FFF6CC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3600_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.448 20.2791C109.598 19.9988 109.494 19.6494 109.213 19.4986C108.933 19.3478 108.584 19.4527 108.433 19.7329L105.947 24.3508L103.892 23.2446C103.612 23.0938 103.262 23.1987 103.112 23.4789C102.961 23.7591 103.066 24.1085 103.346 24.2594L106.416 25.9118L109.448 20.2791Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.474 20.7936C114.672 24.7849 112.408 28.9918 108.416 30.19C104.425 31.3882 100.218 29.1239 99.0201 25.1326C97.8219 21.1412 100.086 16.9343 104.078 15.7362C108.069 14.538 112.276 16.8023 113.474 20.7936ZM112.37 21.1249C113.385 24.5067 111.467 28.0711 108.085 29.0862C104.703 30.1014 101.139 28.183 100.124 24.8012C99.1086 21.4195 101.027 17.8551 104.409 16.8399C107.791 15.8247 111.355 17.7432 112.37 21.1249Z",
    fill: "#0D0D0D"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 36.7239,
    height: 36.7238,
    rx: 9.18097,
    transform: "matrix(-0.981773 -0.190055 -0.190054 0.981774 91.6416 128.707)",
    fill: "#FFF6CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3588 136.192C78.7454 134.656 76.8077 134.37 75.1162 134.606C73.8209 134.787 72.6346 135.275 71.7568 135.777C71.1295 134.984 70.2112 134.088 69.0769 133.437C67.5956 132.587 65.6912 132.129 63.6213 132.952C60.8573 134.05 59.9977 136.514 59.8781 138.522C59.764 140.437 60.689 142.137 61.6157 143.508L67.7914 152.649C67.9399 152.869 68.1745 152.996 68.4198 153.015C68.6545 153.089 68.9195 153.059 69.1392 152.91L78.2799 146.734C79.6516 145.808 81.1442 144.575 81.7529 142.757C82.3913 140.849 82.5133 138.242 80.3588 136.192ZM68.784 151.133L63.0005 142.573C62.1082 141.252 61.4671 139.95 61.5463 138.621C61.6451 136.964 62.3115 135.27 64.2384 134.505C65.7147 133.918 67.0798 134.218 68.2449 134.886C69.4299 135.567 70.35 136.602 70.8194 137.332C70.9519 137.538 71.1597 137.667 71.3836 137.705C71.6054 137.753 71.8461 137.712 72.0459 137.57C72.7538 137.068 73.994 136.45 75.3472 136.261C76.6777 136.076 78.056 136.307 79.2067 137.402C80.7087 138.832 80.6949 140.652 80.168 142.226C79.7456 143.489 78.6651 144.457 77.3443 145.35L68.784 151.133Z",
    fill: "#0D0D0D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1992 53.2856C73.7552 54.2086 73.3433 55.1507 72.8811 56.0645",
    stroke: "#0D0D0D",
    strokeWidth: 1.71123,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0254 52.0076C60.4733 53.054 60.8385 54.1322 61.2708 55.1842",
    stroke: "#0D0D0D",
    strokeWidth: 1.71123,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9811 63.0079C51.4822 62.6123 50.0282 62.0659 48.5307 61.6668",
    stroke: "#0D0D0D",
    strokeWidth: 1.71123,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6068 77.3227C49.1642 77.8465 47.7043 78.4017 46.2192 78.795",
    stroke: "#0D0D0D",
    strokeWidth: 1.71123,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3600_1559",
    x: 10.7602,
    y: 53.6872,
    width: 213.667,
    height: 99.6059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.45527
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18291
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3600_1559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3600_1559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3600_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7556,
    height: 19.7556,
    fill: "white",
    transform: "matrix(0.957775 -0.28752 0.287519 0.957775 93.9463 16.3425)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureContratIllu);
export default __webpack_public_path__ + "static/media/signatureContratIllu.43f77af55cb586aab9621ea36d82647c.svg";
export { ForwardRef as ReactComponent };